/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const KeyIsNotNullAnnotationKey: core.serialization.ObjectSchema<
    serializers.KeyIsNotNullAnnotationKey.Raw,
    Truvity.KeyIsNotNullAnnotationKey
> = core.serialization.object({
    key: core.serialization.string(),
});

export declare namespace KeyIsNotNullAnnotationKey {
    export interface Raw {
        key: string;
    }
}
